const loginForm = document.querySelector("#main:has(.bss-fl-message) form[action='/account/login']");
if (loginForm) {
  const formData = new FormData(loginForm);
  const returnUrl = formData.get("return_url");
  window.location.href = `/account/login?checkout_url=${returnUrl}`;
}

setTimeout(() => {
  if (window.location.href.includes("checkout_url=")) {
    const registerLink = document.querySelector("#customer_login a[href^='/account/register']");
    if (registerLink) {
      registerLink.setAttribute("href", "/pages/provider-register");
    }
  }
}, 500);

if (typeof BSS_B2B !== "undefined") {
  setTimeout(() => {
    const targetCarts = document.querySelectorAll('[aria-controls="cart-drawer"], .product-info__buy-buttons .buy-buttons');
    targetCarts.forEach((targetCart) => {
        targetCart.addEventListener("click", () => {
            setTimeout(() => {
                const cartList = BSS_B2B.shopData.cart.items;
                const subTotal = document.querySelector(".rebuy-cart__flyout-subtotal-amount");

                if (cartList && cartList.length > 0) {
                    const rebuyCartItems = document.querySelectorAll(".rebuy-cart__flyout-items .rebuy-cart__flyout-item");
                    rebuyCartItems.forEach((rebuyCartItem, index) => {
                        const item = cartList[index];
                        const priceElement = rebuyCartItem.querySelector(".rebuy-cart__flyout-item-price");
                        priceElement.setAttribute("bss-b2b-cart-item-key", item.key);
                        priceElement.setAttribute("bss-b2b-item-original-price", "");
                    });
                }
    
                if (subTotal && !subTotal.getAttribute("bss-b2b-cart-total-price")) {
                    subTotal.setAttribute("bss-b2b-cart-total-price", "");
                }
    
                BSS_B2B.observer.cartSubject.notifyObserver("CartMutate", "CartPriceMutate");
            }, 3000);
            const checkoutBtn = document.querySelector(".rebuy-cart__checkout-button");
            if (checkoutBtn && !document.querySelector(".checkout-btn")) {
              checkoutBtn.insertAdjacentHTML("afterend", `<div class='${checkoutBtn.classList} checkout-btn'>${checkoutBtn.innerText}</div>`);
              checkoutBtn.style.display = "none";
            }
        });
    });
  }, 3000);
}


const checkoutUrls = ['/checkout', '/cart/checkout']
const checkoutFetchOverride = () => {
    if (!window.fetch || typeof window.fetch !== 'function') return;
    const originalFetch = window.fetch;

    window.fetch = function () {
        const response = originalFetch.apply(this, arguments);
        if (checkoutUrls.some(url => arguments[0].includes(url)) && document.querySelector(".checkout-btn")) {
            document.querySelector(".checkout-btn").click();
        }

        return response;
    };
};

const lazyLoad = async () => {
  const resL = await BSS_B2B.storage.productStorage.load();
  if (resL.notExistProductIds?.length || resL.productIds?.length || resL.variantIds?.size) {
      BSS_B2B.observer.productSubject.notifyObserver("LazyProduct","LoadedLazyProduct", {
          ...resL,
      });
  }
}
setTimeout(() => {
  lazyLoad()
}, 1000)